var _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/arrow-right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.9685745,15.8100496 L5.29294025,9.1344154 C4.97101318,8.81245479 4.97101318,8.29050156 5.29294025,7.96857449 L6.07154285,7.18997189 C6.39296675,6.86854799 6.9138801,6.86794419 7.23604198,7.18859656 L12.5515117,12.4791427 L17.8669479,7.18859656 C18.1891098,6.86794419 18.7100231,6.86854799 19.031447,7.18997189 L19.8100496,7.96857449 C20.1319767,8.2905351 20.1319767,8.81248834 19.8100496,9.1344154 L13.1344489,15.8100496 C12.8124883,16.1319767 12.2905351,16.1319767 11.9685745,15.8100496 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/arrow-right",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "arrow-right",
    fill: "#000000",
    fillRule: "nonzero",
    transform: "translate(12.551495, 11.500000) rotate(-90.000000) translate(-12.551495, -11.500000) ",
    xlinkHref: "#path-1"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.ec79847b.svg";
export { ForwardRef as ReactComponent };